<template>
    <div >
      <DxPopup
        :visible="isVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"        
        :show-close-button="true"
        @hidden="onHiddenReport"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="Title"       
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"       
      >
        <div>
            <MdTitle v-bind:Text="$t('PostPayman.PDetails')"/>
            <div class="m-3 row">
              <div class="col col-6">
                <p>{{'Insurance.InsuranceCode'}}: {{ header.insuranceCode }}</p>
                <p>{{'PaymentDetailsPopup.PayDate'}}: {{ new Date(header.payDate).toLocaleDateString() }}</p>
                <p>{{'PaymentDetailsPopup.TransNumber'}}: {{ header.transNo }}</p>
              </div>
              <div class="col col-6">
                <p>{{'PaymentDetailsPopup.TotalAmount'}}: {{ Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(header.amount) }}</p>
                <p>{{'PaymentDetailsPopup.PayReference'}}: {{ header.payRef }}</p>
                <p>{{'PaymentDetailsPopup.PayType'}}: {{ header.payType }}</p>
              </div>
            </div>
        </div>
        <div>
          <MdTable 
            :items="items"
            :showMessageIsEmpty="ShowMessageIsEmpty"
            :sticky-header="true"
            :onRowSelected="onRowSelected"
            :fields="fields"
          />             
        </div>
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'

    export default Vue.extend({
        name: "PaymentDetailsPopup",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          Title:String,
          isVisible: Boolean,   
          items: Array,
          fields: Array,
          header: Object,
          closeWindow: Function,
          ShowMessageIsEmpty: Boolean,
          onRowSelected: Function
        },
        data() {
            return {
             
            }
        },
        methods: {
            onHiddenReport() {
              this.closeWindow()
            },
        },
        
        mounted () {          
         
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  }
</style>
